import { galeKycFieldsSchema } from "@redotech/redo-conversion-hsa-common/rpc-schemas/gale-kyc";
import * as z from "zod";

/** Saves the merchant-entered KYC payload. Null `onboardingUrl` = review
 * incomplete (saved unvalidated); otherwise the fresh link to redirect to. */
export const submitGaleKycInfo = {
  name: "submitGaleKycInfo" as const,
  input: galeKycFieldsSchema,
  output: z.object({ onboardingUrl: z.string().nullable() }),
};
